module.exports = __webpack_public_path__ + "img/32-linux.30085e9b.png";